import { render, staticRenderFns } from "./ConsultaCliente.vue?vue&type=template&id=d6a57ade&"
import script from "./ConsultaCliente.vue?vue&type=script&lang=js&"
export * from "./ConsultaCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports